module.exports = __webpack_public_path__ + "img/logo.d52ea6b9.png";